<template>
  <Dialog v-model:open="isOpen">
    <DialogContent>
      <div class="tw-px-6 text-center pt-6">
        <p class="h5">
          Signup to Dubb to send webcam, screen, or phone videos like {{ profile.user.name }}
        </p>
        <a
          :href="router('register')"
          class="btn btn-primary mt-4"
          target="_blank"
        >
          Get Dubb for Free
        </a>
      </div>
    </DialogContent>
  </Dialog>
</template>

<script>
import { ref, watch } from 'vue'
import {
  Dialog,
  DialogContent
} from '@/shadcn/components/ui/dialog'

export default {
  name: 'RegisterIntentModal',
  components: {
    Dialog,
    DialogContent
  },
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  setup (_, { expose }) {
    const isOpen = ref(false)
    const hasClosed = ref(false)

    const show = () => {
      if (hasClosed.value) {
        return
      }

      isOpen.value = true
    }

    watch(isOpen, (value) => {
      if (!value) {
        hasClosed.value = true
      }
    })

    expose({
      show
    })

    return {
      isOpen
    }
  }
}
</script>
